export const BI_SAVE = 'BI_SAVE';
